import $oauth2 from '@/libs/OAuth2/services/auth.js';

const getMe = async (forced = false) => {
  try {
    const me = await $oauth2.getMe(forced);
    if (!me) {
      return null;
    }

    return me;
  } catch (err) {
    return null;
  }
};

export default async (to, from, next) => {
  const me = await getMe();

  if (to.meta.auth === false && me) {
    return next({ name: 'root' });
  }

  if (to.meta.auth && !me) {
    return next({ name: 'login' });
  }

  if (typeof to.meta.admin === 'boolean' && !to.meta.admin && me.admin && !me.consultant && !me.investor) {
    return next({ name: 'management' });
  }

  if (typeof to.meta.consultant === 'boolean' && !to.meta.consultant && me.consultant && !me.admin && !me.investor) {
    return next({ name: 'management' });
  }

  if (typeof to.meta.investor === 'boolean' && !to.meta.investor && me.investor && !me.admin && !me.consultant) {
    return next({ name: 'investors-dashboard' });
  }

  if (typeof to.meta.user === 'boolean' && !to.meta.user && !me.consultant && !me.admin && !me.investor) {
    return next({ name: 'operative' });
  }

  return next();
};
